import Layout from '@/layout'
const goodsManagementRouter = {
    path: '/GoodsManagement',
    component: Layout,
    redirect: '/GoodsManagement/GoodsList',
    name: 'GoodsManagement',
    alwaysShow: true,
    meta: {
        title: '商品管理',
        // icon: 'GoodsManagement'
        icon: 'bizOrder'
    },
    children: [
        {
         path: '/GoodsManagement/GoodsList',
         name: "GoodsList",
         component: () => import("@/views/goodsManagement/goodsList/index.vue"),
         meta: {
           title: "商品列表",
         }
       },
       //商品抓取列表
       {
        path: '/GoodsManagement/ProductRetrievalList',
        name: "ProductRetrievalList",
        component: () => import("@/views/goodsManagement/productRetrievalList/index.vue"),
        meta: {
          title: "抓取商品信息补充列表",
        }
      },
     ]
}
export default goodsManagementRouter;

